<div class="fixed bottom-20 sm:bottom-6 md:bottom-1/6 right-4 md:right-9 z-50 transition-all duration-300 txt-button">
  <div
  class="flex items-center bg-button shadow-xl rounded-full p-2"
  [class.w-62]="expanded"
  [class.w-12]="!expanded"
  [class.h-12]="!expanded"
>
  <img src="assets/logos/emergency.svg" alt="alerta" class="w-8 h-8 md:w-10 md:h-10 cursor-pointer" (click)="expanded ? goToAssistence() : toggle()" />
  <span
    class=" headline-04 ml-2 font-semibold whitespace-nowrap"
    *ngIf="expanded"
  >
    <button class="py-2 cursor-pointer" (click)="goToAssistence()">Solicitar {{textAsistencia}}</button>
  </span>
  <button
    *ngIf="expanded"
    class="ml-auto hover:scale-110 transition cursor-pointer"
    (click)="toggle(); $event.stopPropagation()"
  >
    <img src="assets/logos/close.svg" alt="cerrar" class="w-6 h-6 md:w-8 md:h-8 ml-1" />
  </button>
</div>
</div>